<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Contrato de Comisión Mercantil.</li>
      </template>
      <template slot="title">
        Contrato de Comisión Mercantil Solicitante.
      </template>
      <template slot="body">
        <ApplicantMerchantContract />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";
import ApplicantMerchantContract from "@components/contracts/ApplicantMerchantContract";

export default {
  name: "ApplicantMerchantContractPage",
  components: {
    GenericPage,
    ApplicantMerchantContract
  }
}
</script>

<style scoped>

</style>